<div class="container-fluid p-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-credit-card me-2"></i>Contas a Pagar</h2>
      <p class="text-muted mb-0">Gerencie pagamentos a fornecedores</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Nova Conta a Pagar
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="🔍 Buscar por fornecedor, descrição..."
                 [value]="filter.search" (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!loading && result.items.length === 0" class="text-center py-5 text-muted">
        <i class="bi bi-inbox" style="font-size: 3rem;"></i>
        <p class="mt-2">Nenhuma conta a pagar encontrada</p>
      </div>

      <table *ngIf="!loading && result.items.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th>Fornecedor</th>
            <th>Categoria</th>
            <th>Descrição</th>
            <th>Valor</th>
            <th>Vencimento</th>
            <th>Status</th>
            <th>Recorrente</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of result.items">
            <td>{{ p.supplierName || '-' }}</td>
            <td><small class="text-muted">{{ p.categoryName || '-' }}</small></td>
            <td><strong>{{ p.description }}</strong></td>
            <td>{{ fmtCurrency(p.amount) }}</td>
            <td>{{ fmtDate(p.dueDate) }}</td>
            <td>
              <span class="badge" [class.bg-warning]="p.status === 'Pendente'"
                    [class.bg-success]="p.status === 'Pago'"
                    [class.bg-danger]="p.status === 'Vencido'">
                {{ p.status || 'Pendente' }}
              </span>
            </td>
            <td>
              <span *ngIf="p.isRecurring" class="badge bg-info">
                <i class="bi bi-arrow-repeat"></i> {{ p.recurrenceType }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-1" (click)="openModal(p)" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="delete(p)" title="Excluir">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginação -->
      <div *ngIf="result.totalCount > result.pageSize" class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted">
          Exibindo {{ result.items.length }} de {{ result.totalCount }} registros
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="result.page === 1">
              <a class="page-link" (click)="result.page > 1 && onPageChange(result.page - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let p of [].constructor(result.totalPages); let i = index"
                [class.active]="i + 1 === result.page">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="result.page === result.totalPages">
              <a class="page-link" (click)="result.page < result.totalPages && onPageChange(result.page + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingId ? 'Editar' : 'Nova' }} Conta a Pagar</h5>
        <button type="button" class="btn-close" (click)="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">

          <!-- Fornecedor -->
          <div class="col-md-6">
            <label class="form-label">Fornecedor</label>
            <select class="form-select" [(ngModel)]="form.supplierId">
              <option [ngValue]="null">-- Nenhum --</option>
              <option *ngFor="let s of suppliers" [ngValue]="s.id">{{ s.name }}</option>
            </select>
          </div>

          <!-- Categoria -->
          <div class="col-md-6">
            <label class="form-label">Categoria <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="form.categoryId">
              <option [ngValue]="null">-- Selecione --</option>
              <option *ngFor="let c of categories" [ngValue]="c.id">{{ c.name }}</option>
            </select>
          </div>

          <!-- Descrição -->
          <div class="col-md-12">
            <label class="form-label">Descrição <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="form.description">
          </div>

          <!-- Valor -->
          <div class="col-md-4">
            <label class="form-label">Valor <span class="text-danger">*</span></label>
            <input type="number" class="form-control" [(ngModel)]="form.amount" step="0.01">
          </div>

          <!-- Centro de Custo -->
          <div class="col-md-4">
            <label class="form-label">Centro de Custo</label>
            <select class="form-select" [(ngModel)]="form.costCenterId">
              <option [ngValue]="null">-- Nenhum --</option>
              <option *ngFor="let cc of costCenters" [ngValue]="cc.id">{{ cc.name }}</option>
            </select>
          </div>

          <!-- Conta Bancária -->
          <div class="col-md-4">
            <label class="form-label">Conta Bancária</label>
            <select class="form-select" [(ngModel)]="form.bankAccountId">
              <option [ngValue]="null">-- Nenhuma --</option>
              <option *ngFor="let ba of bankAccounts" [ngValue]="ba.id">{{ ba.bankName }} - {{ ba.accountNumber }}</option>
            </select>
          </div>

          <!-- Data de Competência -->
          <div class="col-md-6">
            <label class="form-label">Data de Competência</label>
            <div class="date-input-wrapper">
              <input #competenceDateInput type="text" class="form-control"
                     [(ngModel)]="competenceDateDisplay"
                     (input)="onCompetenceDateInput($event)"
                     placeholder="dd/mm/aaaa"
                     maxlength="10">
              <button type="button" class="date-picker-btn" (click)="toggleCompetenceDatePicker()">
                <i class="bi bi-calendar3"></i>
              </button>
            </div>

            <div class="datepicker-overlay" *ngIf="showCompetenceDatePicker" (click)="showCompetenceDatePicker = false"></div>

            <div class="datepicker-popup" *ngIf="showCompetenceDatePicker"
                 [style.top]="competenceDatePickerTop"
                 [style.left]="competenceDatePickerLeft"
                 (click)="$event.stopPropagation()">
              <div class="datepicker-header">
                <button type="button" class="btn-nav" (click)="competenceDatePickerPreviousMonth()">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="datepicker-month">{{ getCompetenceDatePickerMonthYear() | titlecase }}</span>
                <button type="button" class="btn-nav" (click)="competenceDatePickerNextMonth()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
              <div class="datepicker-weekdays">
                <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
              </div>
              <div class="datepicker-days">
                <div *ngFor="let date of competenceDatePickerDays"
                     class="datepicker-day"
                     [class.other-month]="!competenceDatePickerIsCurrentMonth(date)"
                     [class.today]="competenceDatePickerIsToday(date)"
                     [class.selected]="competenceDatePickerIsSelected(date)"
                     (click)="competenceDatePickerSelectDate(date)">
                  {{ date.getDate() }}
                </div>
              </div>
              <div class="datepicker-footer">
                <button type="button" class="btn btn-sm btn-link" (click)="competenceDatePickerSelectToday()">
                  Hoje
                </button>
              </div>
            </div>
          </div>

          <!-- Data de Vencimento -->
          <div class="col-md-6">
            <label class="form-label">Data de Vencimento <span class="text-danger">*</span></label>
            <div class="date-input-wrapper">
              <input #dueDateInput type="text" class="form-control"
                     [(ngModel)]="dueDateDisplay"
                     (input)="onDueDateInput($event)"
                     placeholder="dd/mm/aaaa"
                     maxlength="10">
              <button type="button" class="date-picker-btn" (click)="toggleDueDatePicker()">
                <i class="bi bi-calendar3"></i>
              </button>
            </div>

            <div class="datepicker-overlay" *ngIf="showDueDatePicker" (click)="showDueDatePicker = false"></div>

            <div class="datepicker-popup" *ngIf="showDueDatePicker"
                 [style.top]="dueDatePickerTop"
                 [style.left]="dueDatePickerLeft"
                 (click)="$event.stopPropagation()">
              <div class="datepicker-header">
                <button type="button" class="btn-nav" (click)="dueDatePickerPreviousMonth()">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="datepicker-month">{{ getDueDatePickerMonthYear() | titlecase }}</span>
                <button type="button" class="btn-nav" (click)="dueDatePickerNextMonth()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
              <div class="datepicker-weekdays">
                <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
              </div>
              <div class="datepicker-days">
                <div *ngFor="let date of dueDatePickerDays"
                     class="datepicker-day"
                     [class.other-month]="!dueDatePickerIsCurrentMonth(date)"
                     [class.today]="dueDatePickerIsToday(date)"
                     [class.selected]="dueDatePickerIsSelected(date)"
                     (click)="dueDatePickerSelectDate(date)">
                  {{ date.getDate() }}
                </div>
              </div>
              <div class="datepicker-footer">
                <button type="button" class="btn btn-sm btn-link" (click)="dueDatePickerSelectToday()">
                  Hoje
                </button>
              </div>
            </div>
          </div>

          <!-- Forma de Pagamento -->
          <div class="col-md-6">
            <label class="form-label">Forma de Pagamento</label>
            <input type="text" class="form-control" [(ngModel)]="form.paymentMethod" placeholder="Ex: Dinheiro, Cartão, PIX">
          </div>

          <!-- Status -->
          <div class="col-md-6">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="form.status">
              <option value="Pendente">Pendente</option>
              <option value="Pago">Pago</option>
              <option value="Vencido">Vencido</option>
              <option value="Cancelado">Cancelado</option>
            </select>
          </div>

          <!-- RECORRÊNCIA -->
          <div class="col-12">
            <hr class="my-3">
            <h6 class="text-primary"><i class="bi bi-arrow-repeat me-2"></i>Recorrência</h6>
          </div>

          <div class="col-md-12">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="isRecurring" [(ngModel)]="form.isRecurring">
              <label class="form-check-label" for="isRecurring">
                Esta conta é recorrente (mensal, quinzenal, etc.)
              </label>
            </div>
          </div>

          <div *ngIf="form.isRecurring" class="col-12">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Tipo de Recorrência</label>
                <select class="form-select" [(ngModel)]="form.recurrenceType">
                  <option *ngFor="let type of recurrenceTypes" [value]="type.value">{{ type.label }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Número de Ocorrências</label>
                <input type="number" class="form-control" [(ngModel)]="form.recurrenceOccurrences"
                       placeholder="Ex: 12 (deixe vazio para indefinido)" min="1">
                <small class="text-muted">Quantas vezes esta conta se repetirá? (Ex: 12 para um ano)</small>
              </div>
            </div>

            <div class="alert alert-info mt-3 d-flex align-items-start gap-2" *ngIf="!editingId">
              <i class="bi bi-info-circle fs-5"></i>
              <div>
                <strong>Atenção:</strong> Ao salvar, serão criadas automaticamente
                <strong>{{ form.recurrenceOccurrences || 1 }}</strong>
                conta(s) a pagar com vencimentos {{ form.recurrenceType?.toLowerCase() }}s.
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showModal = false" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          {{ saving ? 'Salvando...' : (form.isRecurring && !editingId ? 'Criar Recorrências' : 'Salvar') }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
